import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function DiscountModal({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      const script = document.createElement("script");
      script.src = "https://link.msgsndr.com/js/form_embed.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
        <DialogHeader className="mb-2">
          <DialogTitle className="text-2xl font-bold text-primary">Claim 30% Off Annual Plan</DialogTitle>
          <DialogDescription>
            Submit your details and commit to a 1-year plan to instantly secure your 30% discount as a new customer.
          </DialogDescription>
        </DialogHeader>
        <div className="w-full min-h-[500px]">
          <iframe
            src="https://api.leadconnectorhq.com/widget/form/yijOqsph1Atxpme0A6c6"
            style={{ width: "100%", height: "100%", border: "none", borderRadius: "8px", minHeight: "500px" }}
            id="inline-yijOqsph1Atxpme0A6c6"
            data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="30% Off 1 year commitment Form "
            data-height="undefined"
            data-layout-iframe-id="inline-yijOqsph1Atxpme0A6c6"
            data-form-id="yijOqsph1Atxpme0A6c6"
            title="30% Off 1 year commitment Form "
          ></iframe>
        </div>
      </DialogContent>
    </Dialog>
  );
}
